import { render, staticRenderFns } from "./LeftSidebar.vue?vue&type=template&id=740969ec&scoped=true&"
import script from "./LeftSidebar.vue?vue&type=script&lang=ts&"
export * from "./LeftSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./LeftSidebar.vue?vue&type=style&index=0&id=740969ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740969ec",
  null
  
)

export default component.exports